/* AtelierNaru - option data for the wood blind configurator.
   Split out of sections/naru-wood-configurator.liquid on 28 July 2026.
   Nothing here is language-dependent at load time: every entry carries both a
   de and an en pair, and the section picks one with T(). Nothing here touches
   prices either - those live in assets/naru-wood*.js and are merged by
   snippets/naru-wood-merge.liquid. This file is pure presentation.

   ILLUSTRATION STYLE, chosen 29 July 2026: a real window seen straight on -
   PVC frame with a profile, glazing bead, glass with a daylight gradient and a
   diagonal reflection, window board below. The blind is always drawn CLOSED,
   slats edge to edge with a hairline between them, the same rule the preview
   in the configurator follows.

   Seen from the front you cannot show depth, so the five mounting types are
   told apart by WHERE the blind sits rather than how deep it is:
     glasfalz  - small, sitting on the glass only
     sash      - covers the sash face, wider than the glass
     clamp     - same as sash, with the clamp brackets hooked over the top
     recess    - the full width of the opening, in front of the whole frame
     wall      - wider than the opening, overlapping the wall on both sides
   Without that rule the recess and the sash icons come out nearly identical,
   which is the opposite of what the step is for. */
(function(){

/* Gradients are defined once for the whole page and referenced by id. Repeating
   them inside all 28 icons would add about 11 KB for no benefit. */
var DEFS=
 '<linearGradient id="nwGlass" x1="0" y1="0" x2=".3" y2="1"><stop offset="0%" stop-color="#DCE9F0"/><stop offset="55%" stop-color="#C6D8E2"/><stop offset="100%" stop-color="#B9CEDA"/></linearGradient>'+
 '<linearGradient id="nwWood" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#DCAE73"/><stop offset="60%" stop-color="#C08F52"/><stop offset="100%" stop-color="#9E6F3B"/></linearGradient>'+
 '<linearGradient id="nwRail" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#5C4334"/><stop offset="100%" stop-color="#31231A"/></linearGradient>'+
 '<linearGradient id="nwPvc" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#FFFFFF"/><stop offset="100%" stop-color="#E4E2DC"/></linearGradient>'+
 '<linearGradient id="nwSteel" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#9AA0A6"/><stop offset="45%" stop-color="#D6DADE"/><stop offset="100%" stop-color="#7C848B"/></linearGradient>';
function mountDefs(){
  if(document.getElementById('nwc-defs')){return;}
  var d=document.createElement('div');
  d.setAttribute('aria-hidden','true');
  d.style.cssText='position:absolute;width:0;height:0;overflow:hidden';
  d.innerHTML='<svg id="nwc-defs" width="0" height="0"><defs>'+DEFS+'</defs></svg>';
  (document.body||document.documentElement).appendChild(d);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',mountDefs);}else{mountDefs();}

function sv(inner){return '<svg viewBox="0 0 120 88" width="96" height="70" role="img" aria-hidden="true">'+inner+'</svg>';}

/* wall, reveal, frame, glass with its reflection */
var BACK='<rect width="120" height="88" fill="#E9E4DA"/>'+
 '<rect x="9" y="3" width="102" height="74" fill="#DAD3C6"/>'+
 '<rect x="12" y="5" width="96" height="71" fill="url(#nwPvc)" stroke="#C4BFB4" stroke-width=".7"/>'+
 '<rect x="20" y="12" width="80" height="57" fill="url(#nwGlass)"/>'+
 '<path d="M20 60L52 12h14L20 69Z" fill="#fff" opacity=".28"/>'+
 '<rect x="20" y="12" width="80" height="57" fill="none" stroke="#AFB6BB" stroke-width=".7"/>';
/* window board and the shadow it throws */
var SILL='<rect x="7" y="76" width="106" height="5" fill="#F0EDE6" stroke="#C4BFB4" stroke-width=".6"/>'+
 '<rect x="7" y="81" width="106" height="2.6" fill="#000" opacity=".13"/>';
function win(inner){return sv(BACK+inner+SILL);}

/* A closed blind: head rail, slats edge to edge with a hairline joint, bottom
   rail. The slat count follows the drop so the density stays believable. */
function blind(x,y,w,drop,opt){
  opt=opt||{};
  var o='',t=y,i;
  if(!opt.norail){o+='<rect x="'+x+'" y="'+y+'" width="'+w+'" height="6" fill="url(#nwRail)"/>';t=y+6;}
  var n=Math.max(3,Math.round(drop/5.5)),h=drop/n;
  o+='<rect x="'+x+'" y="'+t+'" width="'+w+'" height="'+drop+'" fill="url(#nwWood)"/>';
  for(i=1;i<n;i++){o+='<rect x="'+x+'" y="'+(t+i*h-0.25)+'" width="'+w+'" height=".5" fill="#4E351E" opacity=".42"/>';}
  if(opt.tape){
    o+='<rect x="'+(x+w*0.24)+'" y="'+t+'" width="'+(w*0.07)+'" height="'+drop+'" fill="'+opt.tape+'" opacity=".93" stroke="rgba(0,0,0,.18)" stroke-width=".4"/>';
    o+='<rect x="'+(x+w*0.69)+'" y="'+t+'" width="'+(w*0.07)+'" height="'+drop+'" fill="'+opt.tape+'" opacity=".93" stroke="rgba(0,0,0,.18)" stroke-width=".4"/>';
  }
  if(opt.cords){
    o+='<path d="M'+(x+w*0.28)+' '+t+'v'+drop+'M'+(x+w*0.72)+' '+t+'v'+drop+'" stroke="#7C6F5F" stroke-width=".7" opacity=".55" fill="none"/>';
  }
  o+='<rect x="'+x+'" y="'+(t+drop)+'" width="'+w+'" height="2.4" fill="#3A2718"/>';
  return o;
}

/* the five mounting positions, as geometry rather than as labels */
var POS={
  glazing:[22,12,76,24],
  sash:[16,8,88,26],
  recess:[12,5,96,28],
  wall:[3,1,114,30]
};
function at(p,opt){return blind(POS[p][0],POS[p][1],POS[p][2],POS[p][3],opt);}

var CLAMPS='<path d="M34 9V3.5h8V9M78 9V3.5h8V9" fill="none" stroke="url(#nwSteel)" stroke-width="3.6" stroke-linecap="round"/>'+
 '<path d="M34 9V3.5h8V9M78 9V3.5h8V9" fill="none" stroke="#6E767C" stroke-width=".55" opacity=".8"/>';
var WALLBR='<rect x="14" y="0" width="7" height="4" rx="1" fill="url(#nwSteel)" stroke="#6E767C" stroke-width=".5"/>'+
 '<rect x="99" y="0" width="7" height="4" rx="1" fill="url(#nwSteel)" stroke="#6E767C" stroke-width=".5"/>';
var SCREWS='<circle cx="30" cy="8" r="1.6" fill="#8A9199" stroke="#5E666D" stroke-width=".45"/>'+
 '<circle cx="90" cy="8" r="1.6" fill="#8A9199" stroke="#5E666D" stroke-width=".45"/>';

function cord(side,drop){
  var x=side==='l'?17:103;
  return '<path d="M'+x+' 11v'+drop+'" stroke="#8E8578" stroke-width="1.1" fill="none"/>'+
         '<path d="M'+(x+(side==='l'?3:-3))+' 11v'+(drop*0.62)+'" stroke="#B7AF9F" stroke-width="1.6" fill="none" stroke-linecap="round"/>';
}
function chain(side){
  var x=side==='l'?17:103,i,o='';
  o+='<path d="M'+x+' 11c-4.6 0-4.6 46 0 46 4.6 0 4.6-46 0-46z" fill="none" stroke="#8C9298" stroke-width="1.9"/>';
  o+='<path d="M'+x+' 11c-4.6 0-4.6 46 0 46 4.6 0 4.6-46 0-46z" fill="none" stroke="#D3D7DB" stroke-width=".65"/>';
  for(i=0;i<5;i++){o+='<circle cx="'+(x+(side==='l'?-4.3:4.3))+'" cy="'+(18+i*8)+'" r="1.2" fill="#6E767C"/>';}
  return o;
}

var ICON={
 /* ---- mounting ---- */
 mount_glazing:win(at('glazing')+SCREWS),
 mount_sash:win(at('sash')+'<circle cx="24" cy="11" r="1.6" fill="#8A9199" stroke="#5E666D" stroke-width=".45"/><circle cx="96" cy="11" r="1.6" fill="#8A9199" stroke="#5E666D" stroke-width=".45"/>'),
 mount_clamp:win(CLAMPS+at('sash')),
 mount_recess:win(at('recess')),
 mount_wall:win(WALLBR+at('wall')),

 /* ---- operation ---- */
 op_ctl:win(at('recess')+cord('l',46)),
 op_ctr:win(at('recess')+cord('r',46)),
 op_chl:win(at('recess')+chain('l')),
 op_chr:win(at('recess')+chain('r')),
 op_mot:win(at('recess')+'<rect x="14" y="6" width="9" height="4" rx="1" fill="#8A9199"/><circle cx="18.5" cy="8" r="1.1" fill="#C9CDD1"/>'+
   '<rect x="86" y="52" width="18" height="30" rx="4" fill="#F4F3F0" stroke="#6E767C" stroke-width="1.3"/>'+
   '<rect x="89" y="55" width="12" height="7" rx="1.4" fill="#48505A"/>'+
   '<circle cx="95" cy="68" r="2.4" fill="#8A9199"/><circle cx="95" cy="76" r="2.4" fill="#C4C8CC"/>'),
 op_motn:win(at('recess')+'<rect x="14" y="6" width="9" height="4" rx="1" fill="#8A9199"/><circle cx="18.5" cy="8" r="1.1" fill="#C9CDD1"/>'),

 /* ---- ladder ---- */
 lad_cord:win(at('recess',{cords:1})),
 lad_tape:win(at('recess',{tape:'#B7A98F'})),

 /* ---- valance ---- */
 cov_none:win(at('recess')),
 cov_straight:win(at('recess')+'<rect x="11" y="3" width="98" height="9" rx="1" fill="url(#nwWood)" stroke="rgba(0,0,0,.22)" stroke-width=".5"/>'),
 cov_sides:win(at('recess')+'<rect x="11" y="3" width="98" height="9" rx="1" fill="url(#nwWood)" stroke="rgba(0,0,0,.22)" stroke-width=".5"/>'+
   '<rect x="11" y="3" width="5" height="24" fill="#A87840"/><rect x="104" y="3" width="5" height="24" fill="#A87840"/>'),
 cov_left:win(at('recess')+'<rect x="11" y="3" width="98" height="9" rx="1" fill="url(#nwWood)" stroke="rgba(0,0,0,.22)" stroke-width=".5"/>'+
   '<rect x="11" y="3" width="5" height="24" fill="#A87840"/>'),
 cov_right:win(at('recess')+'<rect x="11" y="3" width="98" height="9" rx="1" fill="url(#nwWood)" stroke="rgba(0,0,0,.22)" stroke-width=".5"/>'+
   '<rect x="104" y="3" width="5" height="24" fill="#A87840"/>'),

 /* ---- side guide ---- */
 gui_none:win(at('recess')),
 gui_cable:win(at('recess')+'<path d="M14 5v71M106 5v71" stroke="#8C9298" stroke-width="1.5" fill="none"/>'+
   '<path d="M14 5v71M106 5v71" stroke="#DCE0E3" stroke-width=".5" fill="none"/>'+
   '<circle cx="14" cy="75" r="2" fill="#6E767C"/><circle cx="106" cy="75" r="2" fill="#6E767C"/>'),

 /* ---- child safety: the winder that takes up the operating cord ---- */
 safe_yes:win(at('recess')+cord('l',34)+
   '<rect x="11" y="48" width="12" height="15" rx="2.5" fill="#F4F3F0" stroke="#6E767C" stroke-width="1.2"/>'+
   '<path d="M14 52c4 0 4 7 0 7M20 52c-4 0-4 7 0 7" fill="none" stroke="#B7AF9F" stroke-width="1.1"/>'+
   '<circle cx="17" cy="55.5" r="1.5" fill="#8A9199"/>'),
 safe_no:win(at('recess')+cord('l',52)+
   '<circle cx="17" cy="58" r="11" fill="none" stroke="#B3261E" stroke-width="2.4"/>'+
   '<path d="M9.5 50.5l15 15" stroke="#B3261E" stroke-width="2.4"/>')
};

var MOUNT=[
 {k:'glazing',ic:'mount_glazing',de:['Im Glasfalz','In die Glasleiste geschraubt, direkt vor der Scheibe. Glasleiste mind. 20 mm tief.'],en:['In the glazing bead','Screwed into the glazing bead, right in front of the pane. Bead at least 20 mm deep.']},
 {k:'sash',ic:'mount_sash',de:['Auf dem Fensterfl\u00fcgel','Mit Kombitr\u00e4gern auf den Fl\u00fcgel geschraubt.'],en:['On the window sash','Screwed onto the sash with combination brackets.']},
 {k:'clamp',ic:'mount_clamp',de:['Fl\u00fcgel ohne Bohren','Klemmtr\u00e4ger, kein Bohren. Nur Kunststofffenster, 20 mm Platz n\u00f6tig.'],en:['Sash, no drilling','Clamp brackets, no drilling. PVC windows only, 20 mm clearance.']},
 {k:'recess',ic:'mount_recess',de:['In der Nische','An die Decke der Fensternische geschraubt.'],en:['In the recess','Screwed to the ceiling of the window recess.']},
 {k:'wall',ic:'mount_wall',de:['An der Wand','An Wand oder Decke vor der Nische.'],en:['On the wall','On the wall or ceiling in front of the recess.']}
];

/* Index matters: 0/1 cord, 2/3 chain, 4/5 motor. opList() slices by these. */
var OPS=[
 {k:'ct-l',ic:'op_ctl',side:'l',de:['Schnur / Wendestab links','Zugschnur und Wendestab auf der linken Seite.'],en:['Cord / tilt rod left','Pull cord and tilt rod on the left.']},
 {k:'ct-r',ic:'op_ctr',side:'r',de:['Schnur / Wendestab rechts','Zugschnur und Wendestab auf der rechten Seite.'],en:['Cord / tilt rod right','Pull cord and tilt rod on the right.']},
 {k:'ch-l',ic:'op_chl',side:'l',de:['Endlos-Kette links','Heben und Wenden \u00fcber eine Kette links. Ab 380 mm Breite.'],en:['Endless chain left','Raise and tilt with one chain on the left. From 380 mm width.']},
 {k:'ch-r',ic:'op_chr',side:'r',de:['Endlos-Kette rechts','Heben und Wenden \u00fcber eine Kette rechts. Ab 380 mm Breite.'],en:['Endless chain right','Raise and tilt with one chain on the right. From 380 mm width.']},
 {k:'mot-r',ic:'op_mot',side:'',de:['Motor mit Fernbedienung','MOTION CM06 Akkumotor. Heben, Senken und Wenden per Funk. Fernbedienung liegt bei.'],en:['Motorised with remote','MOTION CM06 battery motor. Raise, lower and tilt by radio. Remote included.']},
 {k:'mot-n',ic:'op_motn',side:'',de:['Motor ohne Fernbedienung','Derselbe Akkumotor, ohne Fernbedienung \u2013 f\u00fcr jedes weitere Fenster.'],en:['Motorised without remote','The same battery motor, no remote \u2013 for every further window.']}
];

var LAD=[
 {k:'cord',ic:'lad_cord',de:['Schnurleiter','Standard, unauff\u00e4llig.'],en:['Cord ladder','Standard, discreet.']},
 {k:'tape',ic:'lad_tape',de:['Textilband 12 mm','Breites Band, deckt die Bohrungen ab.'],en:['12 mm textile tape','Wide tape, hides the slat holes.']}
];

/* Names are descriptive, read off the real photographs - they are NOT the
   supplier's official colour names. The code (LN xx) is what goes to the
   factory, in a hidden property. The drawn icon is only a fallback: PHOTO
   below wins whenever the real photograph loads. */
var LN=[
 {k:'LN 01',hex:'#F1F1F1',ic:'ln_01',nde:'Wei\u00df',nen:'White'},
 {k:'LN 04',hex:'#A76337',ic:'ln_04',nde:'Cognac',nen:'Cognac'},
 {k:'LN 08',hex:'#0E0E0D',ic:'ln_08',nde:'Schwarzbraun',nen:'Black-brown'},
 {k:'LN 24',hex:'#AFB0B2',ic:'ln_24',nde:'Hellgrau',nen:'Light grey'},
 {k:'LN 27',hex:'#141414',ic:'ln_27',nde:'Schwarz',nen:'Black'},
 {k:'LN 42',hex:'#6F6256',ic:'ln_42',nde:'Taupe',nen:'Taupe'}
];
LN.forEach(function(c){
  ICON[c.ic]=win(at('recess',{tape:c.hex}));
  c.de=[c.nde,'Textilband 12 mm'];
  c.en=[c.nen,'12 mm textile tape'];
});

var COV=[
 {k:'none',ic:'cov_none',de:['Ohne Blende','Die Oberschiene bleibt sichtbar.'],en:['No valance','The head rail stays visible.']},
 {k:'straight',ic:'cov_straight',de:['Gerade Blende','Holzblende in Lamellenfarbe vor der Oberschiene.'],en:['Straight valance','Wooden valance in the slat colour, front only.']},
 {k:'sides',ic:'cov_sides',de:['Mit Seitenteilen','Blende vorn und an beiden Seiten geschlossen.'],en:['With sides','Valance closed at the front and both sides.']},
 {k:'left',ic:'cov_left',de:['Mit linker Seite','Blende vorn und links geschlossen.'],en:['With left side','Valance closed at the front and left.']},
 {k:'right',ic:'cov_right',de:['Mit rechter Seite','Blende vorn und rechts geschlossen.'],en:['With right side','Valance closed at the front and right.']}
];

var GUI=[
 {k:'none',ic:'gui_none',de:['Ohne Seitenf\u00fchrung','Die Jalousie h\u00e4ngt frei.'],en:['No side guide','The blind hangs free.']},
 {k:'cable',ic:'gui_cable',de:['Stahlseil-F\u00fchrung','Seile an beiden Seiten \u2013 die Jalousie schwingt nicht beim \u00d6ffnen des Fensters.'],en:['Steel cable guide','Cables on both sides \u2013 the blind will not swing when the window opens.']}
];

var SAFE=[
 {k:'yes',ic:'safe_yes',de:['Mit Kindersicherung','Schnuraufwickler nach EN 13120, mindestens 150 cm \u00fcber dem Boden montieren.'],en:['With child safety','Cord winder to EN 13120, mount at least 150 cm above the floor.']},
 {k:'no',ic:'safe_no',de:['Ohne Kindersicherung','Nur f\u00fcr R\u00e4ume ohne kleine Kinder.'],en:['Without child safety','Only for rooms without small children.']}
];

/* Real photographs from Shopify Files, used instead of the drawings for the
   tape colours. Same keys as ICON. */
var CDN='https://cdn.shopify.com/s/files/1/1092/7505/4418/files/';
var PHOTO={
 ln_01:CDN+'LN01.png?v=1784559263&width=480',
 ln_04:CDN+'LN04.png?v=1784559263&width=480',
 ln_08:CDN+'LN08.png?v=1784559263&width=480',
 ln_24:CDN+'LN24.png?v=1784559263&width=480',
 ln_27:CDN+'LN27.png?v=1784559263&width=480',
 ln_42:CDN+'LN42.png?v=1784559264&width=480'
};

window.NWC_UI={ICON:ICON,MOUNT:MOUNT,OPS:OPS,LAD:LAD,LN:LN,COV:COV,GUI:GUI,SAFE:SAFE,PHOTO:PHOTO,WOOD:'#C89A5B',DARK:'#4A3428',GREY:'#9AA0A6'};
})();
